import { useState } from 'react';

interface WindowSize {
  width: number;
  height: number;
  isMobile: boolean;
}

// The size when the component mounts; it does not follow later resizes (its one caller, Reservations, reads it once).
export const useWindowSize = (): WindowSize => {
  const [windowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth < 768,
  });

  return windowSize;
};
